const STATUS_MAP = {
  validating: 'pending',
};

import angular from 'angular';

export default angular
  .module('app.filters.fym-status', [])
  .filter('fymStatus', () => {
    return (status = '') => {
      return STATUS_MAP[status] || status;
    };
  });
